export function initScores(experience) {
  /**
   * Score
   */
  const caughtValue = document.querySelector(".caught-value");
  experience.caughtCount = 0;
  caughtValue.textContent = experience.caughtCount;
  experience.updateCaught = () => {
    experience.caughtCount++;
    caughtValue.textContent = experience.caughtCount;
  };

  /**
   * Escaped Grinches
   */
  const escapedGrinches = document.querySelector(".escaped-value");
  experience.escapedCount = 0;
  escapedGrinches.textContent = experience.escapedCount;
  experience.updateEscaped = () => {
    experience.escapedCount++;
    escapedGrinches.textContent = experience.escapedCount;
  };

  /**
   * Total percent
   */
  const total = document.querySelector(".total");
  total.textContent = "0 / 0";
  experience.updateTotal = () => {
    experience.total = experience.caughtCount + experience.escapedCount;
    total.textContent = `${experience.caughtCount} / ${experience.total}`;
  };
}
